


















import { Vue, Component } from 'vue-property-decorator';
import compliance from '@/assets/safety/compliance.png';
import infoSecurity from '@/assets/safety/info-security.png';
import finacialSecurity from '@/assets/safety/finacial-security.png';
import riskControl from '@/assets/safety/risk-control.png';
@Component({
  components: {},
})
export default class Safety extends Vue {
  items = [
    {
      itemTitle: this.$t('具备合规资质'),
      itemContent: this.$t('具备跨境支付业务合规资质，严格遵循各地监管机构要求，与全球合作伙伴紧密协作，确保每一笔资金合规跨境。'),
      itemImg: compliance,
    },
    {
      itemTitle: this.$t('守护资金安全'),
      itemContent: this.$t('遵循银行级资金安全管控标准，所有交易通过HTTPS安全信道传输并使用RSA密钥进行加密，严格守护您的资金安全。'),
      itemImg: finacialSecurity,
    },
    {
      itemTitle: this.$t('严守风控底线'),
      itemContent: this.$t('基于智能风控体系，每笔交易多重安全策略检测，层层把关交易安全。'),
      itemImg: riskControl,
    },
    {
      itemTitle: this.$t('保障信息安全'),
      itemContent: this.$t('遵循金融机构数据安全规范，持有多项安全认证，通过多重加密措施保障用户信息安全。'),
      itemImg: infoSecurity,
    },
  ];
}
